/**
 * `new Date(value)` that cannot crash a render: null when the value is missing
 * or is not a date. `format` and `formatDistanceToNow` from date-fns throw a
 * RangeError on an invalid Date, and inside a table cell that takes the whole
 * table down. Dates that come from an API are strings the schema does not
 * validate as dates, so every cell that formats one goes through here.
 */
export const parseDate = (value: string | null | undefined): Date | null => {
  if (!value) return null;

  const date = new Date(value);

  return Number.isNaN(date.getTime()) ? null : date;
};
